import React, { useEffect, useState } from "react";
import Link from "next/link";
import bannerboy from "../public/images/home/homeimagetransparent.png";

const WelcomePopup = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const alreadySeen = sessionStorage.getItem("welcomePopusSeen");
    if (!alreadySeen) {
      setIsVisible(true);
    }
  }, []);

  const closePopup = () => {
    sessionStorage.setItem("welcomePopusSeen", "true");
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <>
      <style>{`
        @keyframes popupFadeIn {
          from { opacity: 0; transform: scale(0.92); }
          to   { opacity: 1; transform: scale(1); }
        }
        .wp-box {
          animation: popupFadeIn 0.35s ease;
          display: flex;
          background: #fff;
          border-radius: 20px;
          overflow: hidden;
          max-width: 860px;
          width: 95%;
          position: relative;
          box-shadow: 0 20px 60px rgba(0,0,0,0.25);
        }
        .wp-left {
          flex: 1;
          padding: 52px 44px 44px;
          display: flex;
          flex-direction: column;
          justify-content: center;
        }
        .wp-right {
          width: 340px;
          flex-shrink: 0;
          position: relative;
          background: linear-gradient(160deg, #DB6827 0%, #c45a1f 100%);
          overflow: hidden;
        }
        .wp-badge {
          display: inline-flex;
          align-items: center;
          gap: 6px;
          background: #fef3c7;
          color: #92400e;
          font-weight: 700;
          font-size: 12px;
          border-radius: 100px;
          padding: 5px 14px;
          margin-bottom: 20px;
          text-transform: uppercase;
          letter-spacing: 0.6px;
        }
        .wp-badge-dot {
          width: 8px;
          height: 8px;
          border-radius: 50%;
          background: #ef4444;
          display: inline-block;
          animation: blink 1.2s infinite;
        }
        @keyframes blink {
          0%, 100% { opacity: 1; }
          50% { opacity: 0.2; }
        }
        .wp-heading {
          font-size: 28px;
          font-weight: 800;
          color: #0f172a;
          line-height: 1.28;
          margin-bottom: 14px;
        }
        .wp-heading span {
          color: #DB6827;
        }
        .wp-body {
          font-size: 14.5px;
          color: #64748b;
          line-height: 1.7;
          margin-bottom: 24px;
        }
        .wp-offer-pill {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          background: linear-gradient(90deg, #DB6827, #e8863e);
          color: #fff;
          font-size: 13px;
          font-weight: 700;
          border-radius: 100px;
          padding: 8px 20px;
          margin-bottom: 22px;
          letter-spacing: 0.3px;
        }
        .wp-cta {
          display: inline-block;
          background: linear-gradient(90deg, #DB6827, #c45a1f);
          color: #fff !important;
          font-weight: 700;
          font-size: 15px;
          padding: 14px 34px;
          border-radius: 10px;
          text-decoration: none !important;
          box-shadow: 0 4px 18px rgba(219,104,39,0.4);
          transition: transform 0.18s, box-shadow 0.18s;
          margin-bottom: 14px;
          align-self: flex-start;
        }
        .wp-cta:hover {
          transform: translateY(-2px);
          box-shadow: 0 8px 24px rgba(219,104,39,0.5);
          color: #fff !important;
        }
        .wp-note {
          font-size: 12px;
          color: #94a3b8;
        }
        .wp-features {
          list-style: none;
          padding: 0;
          margin: 0 0 26px;
          display: flex;
          flex-direction: column;
          gap: 10px;
        }
        .wp-features li {
          display: flex;
          align-items: center;
          gap: 10px;
          font-size: 14px;
          color: #334155;
        }
        .wp-features li::before {
          content: "";
          width: 20px;
          height: 20px;
          border-radius: 50%;
          background: #fff7ed;
          flex-shrink: 0;
          background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20' fill='%23DB6827'%3E%3Cpath fill-rule='evenodd' d='M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z' clip-rule='evenodd'/%3E%3C/svg%3E");
          background-size: 12px;
          background-repeat: no-repeat;
          background-position: center;
        }
        .wp-close {
          position: absolute;
          top: 16px;
          right: 18px;
          background: #f1f5f9;
          border: none;
          width: 34px;
          height: 34px;
          border-radius: 50%;
          font-size: 18px;
          cursor: pointer;
          color: #64748b;
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 10;
          transition: background 0.15s;
        }
        .wp-close:hover {
          background: #e2e8f0;
        }
        .wp-right-label {
          position: absolute;
          bottom: 28px;
          left: 0;
          right: 0;
          text-align: center;
          color: rgba(255,255,255,0.85);
          font-size: 13px;
          font-weight: 600;
          letter-spacing: 0.5px;
          padding: 0 16px;
        }
        .wp-deadline-badge {
          position: absolute;
          top: 22px;
          left: 50%;
          transform: translateX(-50%);
          background: rgba(255,255,255,0.18);
          border: 1px solid rgba(255,255,255,0.4);
          border-radius: 100px;
          padding: 6px 18px;
          font-size: 12px;
          font-weight: 700;
          color: #fff;
          white-space: nowrap;
        }
        @media (max-width: 640px) {
          .wp-right { display: none; }
          .wp-left { padding: 40px 28px 36px; }
          .wp-heading { font-size: 24px; }
        }
      `}</style>

      <div
        style={{
          position: "fixed",
          inset: 0,
          zIndex: 99999,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: "rgba(15,23,42,0.6)",
          backdropFilter: "blur(4px)",
        }}
      >
        <div className="wp-box">
          {/* Close button */}
          <button className="wp-close" onClick={closePopup} aria-label="Close">
            &#x2715;
          </button>

          {/* LEFT — Text content */}
          <div className="wp-left">
            <span className="wp-badge">
              <span className="wp-badge-dot" />
              Limited Time Offer
            </span>

            <h3 className="wp-heading">
              Enroll 
              &amp; Get{" "}
              <span>FREE AirPods!</span>
            </h3>

            <p className="wp-body">
              Don&apos;t miss this exclusive deal — enroll in any of our
              immigration programs and walk away with a brand
              new pair of Apple AirPods, absolutely free!
            </p>

            <ul className="wp-features">
              <li>Free Apple AirPods on enrollment</li>
              <li>Expert visa &amp; immigration guidance</li>
              <li>End-to-end application support</li>
              {/* <li>Offer valid until 31st March only</li> */}
            </ul>

            <Link
              href="/contact-us#contact-form"
              className="wp-cta"
              onClick={closePopup}
            >
              Claim Your Offer &rarr;
            </Link>

            <p className="wp-note">
              {/* *Offer applicable on new enrollments before 31st March 2026. */}
            </p>
          </div>

          {/* RIGHT — Image */}
          <div className="wp-right">
            <img
              src={bannerboy.src}
              alt="Immigration consultation"
              style={{
                position: "absolute",
                inset: 0,
                width: "100%",
                height: "100%",
                objectFit: "cover",
              }}
            />
            <div
              style={{
                position: "absolute",
                inset: 0,
                background:
                  "linear-gradient(to bottom, rgba(0,0,0,0.05) 0%, rgba(0,0,0,0.55) 100%)",
              }}
            />
            {/* <span className="wp-deadline-badge">⏰ Ends 31st March</span> */}
            <p className="wp-right-label">
              The Immigration Gurus
              <br />
              <span style={{ fontWeight: 400, fontSize: "11px" }}>
                Your trusted visa &amp; immigration partner
              </span>
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default WelcomePopup;
